/* eslint-disable import/prefer-default-export */
export const loadingTimeStatuses = {
  plenty: 'bg-success',
  limited: 'bg-warning',
  delayed: 'bg-danger',
  default: '',
};


export const scoreCardScoresStatuses = {
  green: 'bg-success',
  yellow: 'bg-warning',
  red: 'bg-danger',
  default: '',
};
